<template>
  <v-container fluid fill-height>
    <v-layout align-center justify-center column v-if="error">
      <v-flex>
        <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
      </v-flex>
    </v-layout>
    <v-layout justify-center>
      <v-flex  v-if="loading" xs1 sm1 md1 lg1 >
         <app-loading></app-loading>
      </v-flex>
      <v-flex v-else xs12 sm8 md8 lg8 >
        <v-card v-if="listingDetails" class="mb-6">
          <!--              toolbar-->
          <v-toolbar color="primary" text>
            <v-toolbar-title class="black--text">
<!--              <v-icon class="grey&#45;&#45;text mr2">storefront</v-icon>-->
              <v-text-field
                  v-model="listingDetails.listingName"
                  class="text-h6 mt-6 blue--text"
                  prepend-icon="storefront"
                  v-click-outside="updateListingPage"
              ></v-text-field>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small rounded @click="listingActiveStatusDialog = true" class="white black--text font-weight-bold">
              <span v-if="listingDetails.active">
                <v-icon>share</v-icon>
                Online <v-icon class="success--text">fiber_manual_record</v-icon></span>
              <span v-if="!listingDetails.active">Offline <v-icon class="grey--text">fiber_manual_record</v-icon></span>
            </v-btn>
          </v-toolbar>
          <!--              Page details-->
          <v-expansion-panels v-if="user.publicListingId"  accordion>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div v-if="listingDetails.listingContactNumber !== ''" class="font-weight-bold subtitle-1">Page Details</div>
                <div v-if="listingDetails.listingContactNumber === ''" class="font-weight-bold subtitle-1 error--text">*Configure contact number</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>

                <v-card>
                  <v-card-text>
                    <div class="font-weight-light text-sm-center text-md-center">Toolbar Logo</div>
                  </v-card-text>
                  <v-card-text>
                    <div  v-if="listingDetails">
                      <div v-if="listingDetails.publicListing.toolbarLogo">
                        <v-img
                            :src="listingDetails.publicListing.toolbarLogo.url"
                            height="50px"
                            @click="openToolbarLogo"
                            contain/>
                      </div>

                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn  class="blue--text" dark outlined block @click="addToolbarImage">Add Logo</v-btn>
                      </v-card-actions>
                    </div>
                  </v-card-text>
                </v-card>
                <!--                    page header image-->
                <v-card>
                  <v-card-text>
                    <div class="font-weight-light text-sm-center text-md-center" >Header Images</div>
                  </v-card-text>

                    <v-carousel
                        v-if="listingDetails.publicListing.headerImages"
                        cycle
                        hide-delimiter-background
                        show-arrows
                        height="200">
                      <v-carousel-item
                          v-for="img in listingDetails.publicListing.headerImages"
                          :key="img.id"
                      >
                        <v-img
                            :src="img.url"
                            height="200px"
                            contain
                            @click="openHeaderImage(img.id)"
                        ></v-img>
                      </v-carousel-item>
                    </v-carousel>
                    <v-img
                        v-else
                        height="50px"
                        contain/>

                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="blue--text" dark outlined @click="addHeaderImage">Add Image</v-btn>
                    </v-card-actions>

                </v-card>
                <div >
                  <div class="font-weight-light text-sm-center text-md-center" >Items Section</div>
                  <v-img
                      height="50px"
                      contain/>
                </div>
                <!--                      footer images-->
                <div >
                  <div class="font-weight-light text-sm-center text-md-center" >Footer Images</div>
                  <div v-if="listingDetails.publicListing.footerImages">
                    <div v-for="img in listingDetails.publicListing.footerImages" :key="img.id">
                      <v-img
                          @click="openFooterImage(img.id)"
                          :src="img.url"
                          height="100px"
                          contain/>
                    </div>
                  </div>
                  <div v-else>
                    <v-img
                        height="100px"
                        contain/>
                    <v-img
                        height="100px"
                        contain/>
                  </div>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn class="blue--text" outlined @click="addFooterImage">Add image</v-btn>
                  </v-card-actions>
                </div>

                <!--                    contact number-->
                <v-card-text v-if="listingDetails">
                  <div class="mt-2">
                    <v-icon>support_agent</v-icon>
                    Contact Number
                  </div>
                  <v-select
                      :items="provisionedNumbers"
                      v-model="listingDetails.publicListing.listingContactNumber"
                      label="Contact Number"
                      solo
                  ></v-select>
                  <!--                      Footer note-->
                  <div>
                    <v-icon>local_shipping</v-icon>
                    Footer Note
                  </div>
                  <v-text-field
                      v-model="listingDetails.publicListing.note"
                      label="Add note"
                      placeholder="Example: Open 9am - 10pm"
                  ></v-text-field>
                  <!--Social links-->
                  <div>
                    <v-icon>share</v-icon>
                    Social links
                  </div>
                  <v-row
                    v-for="(icon, index) in socialIcons"
                    :key="index"
                  >
                    <v-col class="mt-6" cols="1">
                      <v-icon>
                        {{ icon.icon }}
                      </v-icon>
                    </v-col>
                    <v-col cols="5">
                     <v-text-field
                      v-model="icon.tag"
                      label="Tag"
                     >
                     </v-text-field>
                    </v-col>
                    <v-col cols="6">
                      <v-text-field
                          v-model="icon.url"
                          label="url"
                          placeholder="www"
                      >
                      </v-text-field>
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="blue" dark @click="updateListingPage">Update</v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                <div class="font-weight-bold subtitle-1 black--text">Payment Options</div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container fluid>
                  <v-row align="center">
                    <v-card-title class="subtitle-1 font-weight-light">Accepted Payment Methods</v-card-title>
                    <v-select
                        v-model="acceptedPaymentMethods"
                        :items="payMethodName"
                        chips
                        item-color="blue"
                        label="Payment Methods"
                        multiple
                        outlined
                    ></v-select>
                  </v-row>
                  <v-row align="center"  v-if="listingDetails.depositConfig">
                    <v-card-title class="subtitle-1 font-weight-light">Deposit options</v-card-title>
                    <v-col
                        class="d-flex"
                        cols="12"
                        sm="6"
                    >
                      <v-select
                          v-if="selectedDeposit"
                          v-model="selectedDeposit"
                          hint="Deposit type"
                          :items="selectDeposits"
                          item-text="typeLabel"
                          label="Select"
                          persistent-hint
                          return-object
                      ></v-select>
                    </v-col>
                    <v-col
                        class="d-flex"
                        cols="12"
                        sm="6"
                        v-if="selectedDeposit"
                    >
                      <div v-if="selectedDeposit.value !== 'notRequired'">
                        <v-text-field
                            v-if="listingDetails.depositConfig.depositType === 'percentOfTotal'"
                            label="Percent of Total"
                            type="number"
                            prepend-icon="percent"
                            v-model="listingDetails.depositConfig.percentOfTotal"
                        ></v-text-field>
                        <v-text-field
                            v-if="listingDetails.depositConfig.depositType === 'fixedAmount'"
                            label="Fixed amount"
                            type="number"
                            prepend-icon="attach_money"
                            v-model="listingDetails.depositConfig.depositAmount"
                        ></v-text-field>
                      </div>

                    </v-col>
                    <v-col
                        class="d-flex"
                        cols="12"
                        sm="6"
                        v-if="selectedDeposit"
                    >
                      <v-text-field
                          v-if="selectedDeposit.value !== 'notRequired'"
                          label="Deposit name"
                          prepend-icon="label"
                          v-model="listingDetails.depositConfig.depositTitle"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="blue" @click="syncAcceptedPaymentMethods()" dark>Update</v-btn>
                </v-card-actions>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </v-card>
<!--        items lists-->
        <v-card v-if="user.publicListingId">
          <v-toolbar color="primary" dark>
            <v-toolbar-title class="black--text"><v-icon class="grey--text">inventory</v-icon> Items</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>

          <!--items list-->
          <v-tabs
              v-model="tabs"
              centered
          >
            <v-tabs-slider color="blue"></v-tabs-slider>

            <v-tab
                v-for="item in tabItems"
                :key="item"
            >
              {{ item }}
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <!--      items tab-->
            <v-tab-item>
              <v-card>
                <v-card-text>
                  <v-btn outlined block class="blue--text" @click="newItemDialog = true">
                    <v-icon>add</v-icon>
                    new item
                  </v-btn>
                </v-card-text>
                <v-list v-if="items.length !== 0" two-line>
                  <!--                <v-list-item-->
                  <!--                    @click="imgRecogDialog = true"-->
                  <!--                >-->
                  <!--                  <v-list-item-avatar>-->
                  <!--                    <v-icon>camera</v-icon>-->
                  <!--                  </v-list-item-avatar>-->
                  <!--                  <v-list-item-content class="text-xs-left">-->
                  <!--                    <v-list-item-title>Auto Image Recognition</v-list-item-title>-->
                  <!--                    <v-list-item-subtitle v-if="imgRecogEnabled">Listed</v-list-item-subtitle>-->
                  <!--                    <v-list-item-subtitle v-else>Un-listed</v-list-item-subtitle>-->
                  <!--                  </v-list-item-content>-->
                  <!--                  <v-list-item-icon>-->
                  <!--                    <div v-if="imgRecogEnabled"><v-icon class="success&#45;&#45;text">fiber_manual_record</v-icon></div>-->
                  <!--                    <div v-else><v-icon class="warning&#45;&#45;text">fiber_manual_record</v-icon></div>-->
                  <!--                  </v-list-item-icon>-->
                  <!--                </v-list-item>-->
                  <v-list-item
                      v-for="item in items"
                      :key="item.id"
                      @click="routeToItem(item.id)"
                  >
                    <v-list-item-icon>
                      <v-img containt max-height="50px" max-width="50px" v-if="item.imgs.length !== 0" :src="item.imgs[0].url" ></v-img>
                      <v-icon v-else>category</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content class="text-xs-left">
                      <v-list-item-title>{{ item.title }}</v-list-item-title>
                      <v-list-item-subtitle v-if="item.listed">Listed</v-list-item-subtitle>
                      <v-list-item-subtitle v-else>Un-listed</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-icon>
                      <div v-if="item.listed"><v-icon class="mt-3 success--text">fiber_manual_record</v-icon></div>
                      <div v-else><v-icon class="mt-3 warning--text">fiber_manual_record</v-icon></div>
                    </v-list-item-icon>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-tab-item>
<!--            add-on items tab-->
            <v-tab-item>
              <v-btn outlined block class="mt-3 mb-3 blue--text" @click="newAddOnItemDialog = true">
                <v-icon>add</v-icon>
                new add-on item
              </v-btn>
              <v-list v-if="addOnItems.length !== 0" two-line>
                <v-list-item
                    v-for="item in addOnItems"
                    :key="item.id"
                    @click="openAddOnItem(item)"
                >
                  <v-list-item-avatar>
                    <v-icon>category</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content class="text-xs-left">
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                    <v-list-item-subtitle v-if="item.listed">Listed</v-list-item-subtitle>
                    <v-list-item-subtitle v-else>Un-listed</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-icon>
                    <div v-if="item.listed"><v-icon class="success--text">fiber_manual_record</v-icon></div>
                    <div v-else><v-icon class="warning--text">fiber_manual_record</v-icon></div>
                  </v-list-item-icon>
                </v-list-item>
              </v-list>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="imageDialog"
              width="500px"
    >
      <v-card>
        <v-img
            v-if="pickedImage"
            :src="pickedImage.url"
            contain
            height="500px"
        >
        </v-img>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined @click="deleteImage" class="red white--text">delete</v-btn>
          <v-btn @click="imageDialog = false">close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="imgRecogDialog"
              width="500px"
    >
      <v-card>
        <v-card-title>
          Auto Image Recognition
        </v-card-title>
        <v-card-text>
          This item lets clients to take a picture and label objects automatically. Detected objects are added to items list.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined v-if="!imgRecogEnabled" @click="enableImgRecog" class="blue white--text">Enable</v-btn>
          <v-btn outlined v-if="imgRecogEnabled" @click="disableImgRecog" class="yellow black--text">Disable</v-btn>
          <v-btn @click="imgRecogDialog = false">cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newItemDialog"
              ref="dialog"
              persistent
              width="360px"
    >
      <v-card>
        <v-card-title>
          <div v-if="!addOnItem" class="white black--text text-xs-center font-weight-thin display-1">New Item</div>
          <div v-else class="white black--text text-xs-center font-weight-thin display-1">New Add-on Item</div>
        </v-card-title>
<!--        Item Attributes-->
        <v-card-text v-if="!loading">
<!--          item name-->
          <v-text-field
              label="Name"
              v-model="newItem.title"
          ></v-text-field>
<!--          item details-->
          <v-row class="mt-6">
            <v-col
                cols="12"
            >
              <v-select
                  :items="itemTypes"
                  label="Item type"
                  v-model="newItem.itemType"
                  outlined
              ></v-select>
              <div v-if="newItem.itemType === 'product'">
                <div v-if="!newItem.onlineOnly">Fulfillment Options</div>
                <div class="subtitle-1">{{fulfillmentMethod}}</div>
                <v-checkbox
                    v-if="!newItem.onlineOnly"
                    color="blue"
                    v-model="newItem.deliveryEnabled"
                    label="Delivery allowed"
                ></v-checkbox>
                <v-checkbox
                    class="ml-3"
                    v-if="!newItem.onlineOnly && newItem.deliveryEnabled"
                    color="blue"
                    v-model="newItem.additionalLocationsEnabled"
                    label="Allow multiple locations"
                ></v-checkbox>
                <v-checkbox
                    v-if="!newItem.onlineOnly"
                    color="blue"
                    v-model="newItem.pickupLocationEnabled"
                    label="Pick up allowed"
                ></v-checkbox>
                <v-checkbox
                    color="blue"
                    v-model="newItem.onlineOnly"
                    label="Online only"
                ></v-checkbox>
              </div>
              <div v-if="newItem.itemType === 'service'">
                <div>Fulfillment Options:</div>
                <v-divider></v-divider>
                <div class="subtitle-1 font-weight-bold mt-2">{{fulfillmentMethod}}</div>
                <v-checkbox
                    color="blue"
                    v-model="newItem.calcTravelTime"
                    label="Include travel time"
                ></v-checkbox>
                <v-checkbox
                    color="blue"
                    v-model="newItem.additionalLocationsEnabled"
                    label="Allow multiple locations"
                ></v-checkbox>
              </div>
            </v-col>

          </v-row>
        </v-card-text>


        <app-loading v-else></app-loading>
        <v-card-actions  v-if="!addOnItem">
          <v-spacer></v-spacer>
          <v-btn @click="newItemDialog = false" text>cancel</v-btn>
          <v-btn :disabled="newItem.title === ''"
                 @click="createItem" dark class="blue">add item</v-btn>
        </v-card-actions>
        <v-card-actions v-if="addOnItem">
          <v-spacer></v-spacer>
          <v-btn @click="cancelAddOnItem" text>cancel</v-btn>
          <v-btn @click="createItem" dark class="blue">create Add-on item</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newAddOnItemDialog"
              ref="dialog"
              persistent
              width="360px"
    >
      <v-card>
        <v-card-title>
          <div class="white black--text text-xs-center font-weight-thin display-1">New Add-on Item</div>
        </v-card-title>
        <!--        Item Attributes-->
        <v-card-text v-if="!loading">
          <!--          add-on item name-->
          <v-text-field
              label="Name"
              v-model="newAddOnItem.title"
          ></v-text-field>
          <!--          add-on item details-->
          <v-text-field
              label="Time required in minutes"
              placeholder="30"
              type="number"
              v-model="newAddOnItem.timeFactor"
          ></v-text-field>
          <v-slider
              v-model="newAddOnItem.travelFactor"
              label="Travel factor"
              thumb-color="blue"
              thumb-label="always"
              min="1"
              max="5"
          ></v-slider>

        </v-card-text>
        <app-loading v-else></app-loading>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="newAddOnItemDialog = false" text>cancel</v-btn>
          <v-btn @click="createAddOnItem" dark class="blue">
            create Add-on item
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="addOnItemDialog"
              ref="dialog"
              persistent
              width="360px"
    >
      <v-card v-if="selectedAddOnItem">
        <v-card-title>
          <div class="white black--text text-xs-center font-weight-thin display-1">Add-on Item</div>
        </v-card-title>
        <!--        Item Attributes-->
        <v-card-text v-if="!loading">
          <!--          add-on item name-->
          <v-text-field
              label="Name"
              v-model="selectedAddOnItem.title"
          ></v-text-field>
          <!--          add-on item details-->
          <v-text-field
              label="Time required in minutes"
              placeholder="30"
              type="number"
              v-model="selectedAddOnItem.timeFactor"
          ></v-text-field>
          <v-slider
              v-model="selectedAddOnItem.travelFactor"
              label="Travel factor"
              thumb-color="blue"
              thumb-label="always"
              min="1"
              max="5"
          ></v-slider>
          <v-switch
              color="blue"
              v-model="selectedAddOnItem.listed"
              label="Listed"
          ></v-switch>
        </v-card-text>

        <app-loading v-else></app-loading>
        <v-card-actions>
          <v-btn @click="deleteAddOnItem" class="red--text" text>delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="addOnItemDialog = false" text>cancel</v-btn>
          <v-btn @click="updateAddonItem" class="blue--text" text outlined>update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="imageUploadDialog"
              ref="dialog"
              persistent
              width="500px"
    >
      <v-card>
        <v-card-title>Select image to upload</v-card-title>
        <gen-img-uploader path="pageViewContent" @imageLinkFound="addImageLink" @removeImage="removeImageLink"></gen-img-uploader>
        <v-card-text v-if="mediaUrl">
          <v-img contain :src="mediaUrl" aspect-ratio="1.7"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelImageUpload">cancel</v-btn>
          <v-btn text :disabled="!mediaUrl" @click="uploadImgToPageDetail">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="toolbarLogoUploadDialog"
              ref="dialog"
              persistent
              width="500px"
    >
      <v-card>
        <v-card-title>Select image to upload</v-card-title>
        <gen-img-uploader path="pageViewContent" @imageLinkFound="addImageLink" @removeImage="removeImageLink"></gen-img-uploader>
        <v-card-text v-if="mediaUrl">
          <v-img contain :src="mediaUrl" aspect-ratio="1.7"></v-img>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="cancelImageUpload">cancel</v-btn>
          <v-btn text :disabled="!mediaUrl" @click="uploadImgToPageDetail()">ok</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="listingActiveStatusDialog"
              ref="dialog"
              persistent
              width="500px"
    >
      <div v-if="listingDetails">
        <v-card v-if="listingDetails.active">
          <v-card-title>Listing is Online
            <v-icon small class="success--text">fiber_manual_record</v-icon>
          </v-card-title>
          <v-card-text class="mb-12">
            <div class="mt-6"> <v-icon>share</v-icon>
              {{ listingDetails.listingName }}</div>
            <qrcode-vue :value="qrCodeLink" size="300" level="H" />
<!--            <a :href="qrCodeLink" style="font-size: 0.8em;">{{qrCodeLink}}</a>-->
          </v-card-text>
          <v-card-text>
            This listing is active and can be viewed here
            <a :href="'https://order.flexline.app/' + this.user.publicListingId + '/' +this.id" target="_blank" class="black--text">
              <v-icon>link</v-icon>
              {{qrCodeLink}}
            </a>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="listingActiveStatusDialog = false">cancel</v-btn>
            <v-btn text outlined dark class="grey" @click="bringListingOffline">Go Offline</v-btn>
          </v-card-actions>
        </v-card>
        <v-card v-if="!listingDetails.active">
          <v-card-title>Listing is Offline
            <v-icon small class="grey--text">fiber_manual_record</v-icon>
          </v-card-title>
          <v-card-text>
            <div class="text-h6">This listing is not public and cannot be viewed.</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="listingActiveStatusDialog = false">cancel</v-btn>
            <v-btn text class="green" dark outlined @click="bringListingOnline">Go Online</v-btn>
          </v-card-actions>
        </v-card>
      </div>
    </v-dialog>
  </v-container>
</template>
<script>
import {collection, doc, updateDoc, addDoc, onSnapshot, setDoc, getDocs, deleteDoc} from "firebase/firestore";
import moment from "moment";
import {v4 as uuid} from "uuid"
import {deleteObject, getStorage, ref} from "firebase/storage";
import QrcodeVue from 'qrcode.vue'
export default {
  props: ['id'],
  components: {
    QrcodeVue,
  },
  data () {
    return {
      tabs: null,
      tabItems: [
        'Items', 'Add-on Items'
      ],
      imgRecogDialog: false,
      newAddOnItemDialog: false,
      listingActive: false,
      newItemDialog: false,
      itemName: '',
      items: [],
      listingDetails: undefined,
      provisionedNumbers: [],
      imageUploadDialog: false,
      imageDialog: false,
      mediaUrl: undefined,
      footerImgUpload: false,
      headerImgUpload: false,
      openFooterImg: false,
      openHeaderImg: false,
      pickedImage: undefined,
      imgPath: '',
      addOnItem: false,
      addOnItems: [],
      imgRecogEnabled: false,
      selectedDeposit: null,
      selectDeposits: [
        { typeLabel: 'Not required', value: 'notRequired' },
        { typeLabel: 'Percent of total', value: 'percentOfTotal' },
        { typeLabel: 'Fixed Amount', value: 'fixedAmount' },
      ],
      acceptedPaymentMethods: [],
      payMethodName: [],
      paymentMethods: null,
      toolbarLogoUploadDialog: false,
      toolbarImageUpload: false,
      viewToolbarLogo: false,
      listingActiveStatusDialog: false,
      newItem: {
        created: Date.now(),
        id: uuid(),
        imgs: [],
        title:'',
        shortDescription: '',
        // variationId: '135264',
        featuresList: [],
        featuredImgs:  [],
        fullDescription: '',
        descriptionMedia: [],
        instruction: 'smallSingleItemDelivery',
        note: '',
        // cost calculation params
        baseRate: 350.00, //dollar amount
        qty: 1,
        costPerAdditionalUnit: 100, //per hour or additional product cost
        includedHours: 3,
        includedKm: 50,
        additionalKmRate: 1.15,
        finalCostMultiplier: 1,
        additionalCost: [],
        addOnItems: [],
        bookingAvailability: '',
        availableOnDemand: false,
        locationLabel: '',
        additionalFeesLabel: '',
        startingLocations: [],
        //item category setters
        deliveryEnabled: false, //for products only
        pickupLocationEnabled: false, //for products only
        onlineOnly: false, //for products only
        itemType: 'service', //product, service
        calcTravelTime: true, //for services only
        additionalLocationsEnabled: false //for both products and services
      },
      newAddOnItem: {
        instruction: '',
        note: '',
        listed: false,
        timeFactor: 10,
        title: '',
        travelFactor: 2,
        qty: 1
      },
      lostAndFoundItems: [],
      itemTypes: ['service', 'product'],
      socialIcons: [
        {icon: 'mdi-facebook', tag: '', url: ''},
        {icon: 'mdi-twitter', tag: '', url: ''},
        {icon: 'mdi-linkedin', tag: '', url: ''},
        {icon: 'mdi-instagram', tag: '', url: ''}
      ],
      selectedAddOnItem: null,
      addOnItemDialog: false
    }
  },
  computed: {
    fulfillmentMethod () {
      let itemCategory = ''
      if (this.newItem.itemType === 'product') {
        if (this.newItem.deliveryEnabled) {
          itemCategory = 'Delivery only'
          if (this.newItem.additionalLocationsEnabled) {
            itemCategory = 'Delivery with multiple stops'
          }
        }
        if (this.newItem.pickupLocationEnabled) {
          itemCategory = 'Pick up Only'
        }
        if (this.newItem.pickupLocationEnabled
            && this.newItem.deliveryEnabled) {
          itemCategory = 'Pick up and Delivery available'

        }
        if (this.newItem.onlineOnly) {
          itemCategory = 'Available online only'
        }
      }
      if (this.newItem.itemType === 'service') {
        if (this.newItem.calcTravelTime) {
          itemCategory = 'Includes cost of travel'
          if (this.newItem.additionalLocationsEnabled) {
            itemCategory = 'Includes travel cost with multiple stops'
          }
        }
        if (this.newItem.additionalLocationsEnabled) {
          itemCategory = 'Multiple locations enabled'
          if (this.newItem.calcTravelTime) {
            itemCategory = 'Includes travel cost with multiple stops'
          }
        }
      }
      return itemCategory
    },
    qrCodeLink () {
      let link
      if (this.user) {
        link = 'https://order.flexline.app/' + this.user.publicListingId + '/' +this.id
      }
      return link
    },
    loading () {
      return this.$store.getters.loading
    },
    moment () {
      return (date) => {
        let day = moment(date).format('ddd, MMM Do, hh:mm:ss A')
        return day
      }
    },
    error () {
      return this.$store.getters.error
    },
    user () {
      return this.$store.getters.user
    },
  },
  watch: {
    selectedDeposit (depositObj) {
      this.listingDetails.depositConfig.depositType = depositObj.value
      if(depositObj.value === 'fixedAmount') {
        if (!this.listingDetails.depositConfig.depositAmount) {
          this.listingDetails.depositConfig.depositAmount = 50
        }
        if (!this.listingDetails.depositConfig.depositTitle) {
          this.listingDetails.depositConfig.depositTitle = 'Booking deposit'
        }
        this.listingDetails.publicListing.depositConfig =  this.listingDetails.depositConfig
      }
      if(depositObj.value === 'percentOfTotal') {
        if (!this.listingDetails.depositConfig.percentOfTotal) {
          this.listingDetails.depositConfig.percentOfTotal = 10
        }
        if (!this.listingDetails.depositConfig.depositTitle) {
          this.listingDetails.depositConfig.depositTitle = 'Booking deposit'
        }
        this.listingDetails.publicListing.depositConfig = this.listingDetails.depositConfig
      }
      if(depositObj.value === 'notRequired') {
        this.listingDetails.depositConfig.percentOfTotal = 0
        this.listingDetails.depositConfig.depositTitle = ''
        this.listingDetails.publicListing.depositConfig = this.listingDetails.depositConfig
      }
      // console.log(depositObj)
    }
  },
  created() {
    this.$store.dispatch('setLoading', true)
    let db = this.$store.state.db
    // fetches items associated by this number
    let listingRef = doc(db, 'users', this.user.uid, 'listings', this.id)
    onSnapshot(listingRef, res => {
      if (res.exists) {
        let data = res.data()
        // console.log(data)
        this.listingDetails = data
        if (data.publicListing.imgRecogEnabled) {
          this.imgRecogEnabled = true
        }
        if (data.publicListing.socialIcons) {
          data.publicListing.socialIcons.forEach(icon => {
            if (icon.tag !== '') {
              let socialIcon = this.socialIcons.find(obj => {
                return obj.icon === icon.icon
              })
              let index = this.socialIcons.indexOf(socialIcon)
              // console.log(index)
              this.socialIcons[index].tag = icon.tag
              this.socialIcons[index].url = icon.url
            }
          })
        }
        // depositTypes: ['Percent of Total', 'Fixed Amount', 'Not Required'],
        if (data.depositConfig) {
           if(data.depositConfig.depositType === 'notRequired') {
             this.selectedDeposit =  { typeLabel: 'Not Required', value: 'notRequired' }
             // console.log(this.selectedListingDepositType)
           }
          if(data.depositConfig.depositType === 'fixedAmount') {
            this.selectedDeposit =  { typeLabel: 'Fixed Amount', value: 'fixedAmount' }
            if(!data.depositConfig.depositAmount) {
              this.listingDetails.depositConfig.depositAmount = 50
              this.listingDetails.depositConfig.depositTitle = 'Booking deposit'
            }
          }
          if(data.depositConfig.depositType === 'percentOfTotal') {
            this.selectedDeposit =  { typeLabel: 'Price of total', value: 'percentOfTotal' }
            if(!data.depositConfig.percentOfTotal) {
              this.listingDetails.depositConfig.percentOfTotal = 10
              this.listingDetails.depositConfig.depositTitle = 'Booking deposit'

            }
          }
        } else {
          this.listingDetails.depositConfig = {depositType: 'notRequired'}
          this.listingDetails.publicListing.depositConfig = {depositType: 'notRequired'}
          this.updateListingPage ()
        }
      }
      this.$store.dispatch('setLoading', false)
    })
    let numbersRef = getDocs(collection(db, 'users', this.user.uid + '/provisionedNumbers'))
    let paymentsRef = getDocs(collection(db, 'users', this.user.uid + '/paymentMethods'))
    // fetching payment methods
    return paymentsRef
        .then (methods => {
          let methodsList = []
          let methodNamesOnly = []
          methods.forEach (method => {
            if(method.data().enabled) {
              methodsList.push(method.data())
              methodNamesOnly.push(method.data().paymentMethod)
            }
          })
          this.paymentMethods = methodsList
          let paymentMethodItems = []
          methodsList.forEach(method => {
            //console.log(method.paymentMethod)
            paymentMethodItems.push(method.paymentMethod)
          })
          this.payMethodName = paymentMethodItems
          if (!this.listingDetails.acceptedPaymentMethods) {
            this.listingDetails.acceptedPaymentMethods = methodsList
            this.acceptedPaymentMethods = paymentMethodItems
          } else {
            let payMethods = []
            this.listingDetails.acceptedPaymentMethods.forEach(method =>{
              payMethods.push(method.paymentMethod)
            })
            this.acceptedPaymentMethods = payMethods
            this.transactionPaymentMethod = payMethods[0]
          }
        })
        .then (() => {
          // fetching provisioned numbers
          return numbersRef.then (numbers => {
            let numbersList = []
            numbers.forEach (number => {
              let phoneNumber = number.data().phoneNumber
              numbersList.push(phoneNumber)
            })
            this.provisionedNumbers = numbersList

            let itemsRef = collection(db, 'users', this.user.uid + '/listings/' + this.id +'/items')
            return getDocs(itemsRef)
          })
        })
        .then((res) => {
          if (!res.empty) {
            let items = []
            let sortedItems = []
            res.forEach(doc => {
              let data = doc.data()
              // console.log(data.id)
              items.push(data)
            })
            sortedItems = items.sort((a, b) => a.title.localeCompare(b.title))
            this.items = sortedItems
          }
          let addOnItemsRef = collection(db, 'users', this.user.uid + '/listings/' + this.id +'/addOnItems')
          return getDocs(addOnItemsRef)
        })
        .then((res) => {
          if (!res.empty) {
            let items = []
            let sortedItems = []
            res.forEach(doc => {
              let data = doc.data()
              //console.log(data.id)
              items.push(data)
            })
            sortedItems = items.sort((a, b) => a.title.localeCompare(b.title))
            this.addOnItems = sortedItems
          }
        })
        .catch(err => {
          console.log(err)
          this.$store.dispatch('setError', err)
        })
  },
  methods: {
    bringListingOnline () {
      this.listingDetails.active = true
      this.updateListingPage()
      // this.listingActiveStatusDialog = false
      // let db = this.$store.state.db
      // let publicListingRef = doc(db, 'publicListings', this.user.publicListingId, 'listings', this.id)
    },
    bringListingOffline () {
      this.listingDetails.active = false
      this.updateListingPage()
      this.listingActiveStatusDialog = false
    },
    setPublicListingStatus () {
      let db = this.$store.state.db
      let publicListingRef = doc(db, 'publicListings', this.user.publicListingId, 'listings', this.id)
      if (this.listingDetails.active) {
        if (this.user.publicListingId) {
          return setDoc(publicListingRef, this.listingDetails.publicListing)
          // this.updateListingPage()
        } else {
          this.setUserListingID()
        }
      }
      //listing is not active
      else {
        // console.log(this.user.publicListingId)
        if (this.user.publicListingId) {
          // console.log('deleted')
          return deleteDoc(publicListingRef)
        } else {
          return this.setUserListingID()
        }
      }
    },
    syncAcceptedPaymentMethods () {
      let selectedPaymentMethods = []
      this.acceptedPaymentMethods.forEach(method => {
        let fullObj = this.paymentMethods.find(methodObj => {
          return methodObj.paymentMethod === method
        })
        selectedPaymentMethods.push(fullObj)
      })
      this.listingDetails.acceptedPaymentMethods = selectedPaymentMethods
      this.listingDetails.publicListing.acceptedPaymentMethods = selectedPaymentMethods
      this.updateListingPage()
    },
    enableImgRecog () {
      this.listingDetails.publicListing.imgRecogEnabled = true
      this.updateListingPage()
      this.imgRecogDialog = false
    },
    disableImgRecog () {
      this.imgRecogEnabled = false
      this.listingDetails.publicListing.imgRecogEnabled = false
      this.updateListingPage()
      this.imgRecogDialog = false
    },
    cancelAddOnItem () {
      this.newItemDialog = false
      this.addOnItem = false
    },
    setUserListingID () {
      // let db = this.$store.state.db
      // let userRef = doc(db, 'users', this.user.uid)
      let userData = this.user
      userData.publicListingId = uuid()
      this.$store.dispatch('updateUserProfile', userData)
    },
    openFooterImage (id) {
      this.openFooterImg = true
      this.openHeaderImg = false
      //console.log(id)
      this.imageSelected (id)
    },
    openHeaderImage (id) {
      this.openFooterImg = false
      this.openHeaderImg = true
      this.imageSelected (id)
    },
    openToolbarLogo () {
      this.toolbarImageUpload = true
      this.openFooterImg = false
      this.openHeaderImg = false
      this.viewToolbarLogo = true
      this.imageSelected ()
    },
    imageSelected (value) {
      if (value) {
        if (this.openFooterImg) {
          this.pickedImage = this.listingDetails.publicListing.footerImages.find(img => {
            return img.id === value
          })
        }
        if (this.openHeaderImg) {
          this.pickedImage = this.listingDetails.publicListing.headerImages.find(img => {
            return img.id === value
          })
        }
        if (this.openHeaderImg) {
          this.pickedImage = this.listingDetails.publicListing.headerImages.find(img => {
            return img.id === value
          })
        }
      } else {
        if (this.viewToolbarLogo) {
          this.pickedImage = this.listingDetails.publicListing.toolbarLogo
        }
      }
      console.log(this.pickedImage)
      this.imageDialog = true
    },
    deleteImage () {
      if (this.openFooterImg) {
        let index = this.listingDetails.publicListing.footerImages.indexOf(this.pickedImage)
        this.listingDetails.publicListing.footerImages.splice(index, 1)
      }
      if (this.openHeaderImg) {
        let index = this.listingDetails.publicListing.headerImages.indexOf(this.pickedImage)
        this.listingDetails.publicListing.headerImages.splice(index, 1)
      }
      if (this.toolbarImageUpload) {
        delete this.listingDetails.publicListing.toolbarLogo
      }
      this.imageDialog = false
      // console.log(this.listingDetails.publicListing)
      this.updateListingPage()
      let userId = this.user.uid
      let storage = getStorage()
      let imgRef = ref(storage, '/users/' + userId + '/pageViewContent/' + this.pickedImage.id)
      deleteObject(imgRef).catch((err) => {
        this.$store.dispatch('setError', err)
      });
    },
    addToolbarImage () {
      this.toolbarImageUpload = true
      this.footerImgUpload = false
      this.headerImgUpload = false
      this.imageUploadDialog = true
    },
    addHeaderImage () {
      this.footerImgUpload = false
      this.headerImgUpload = true
      this.imageUploadDialog = true
      this.toolbarImageUpload = false
    },
    addFooterImage () {
      this.imageUploadDialog = true
      this.headerImgUpload = false
      this.footerImgUpload = true
      this.toolbarImageUpload = false
    },
    addImageLink (value) {
      this.mediaUrl = value.url
      this.imgId = value.id
      this.imgPath = value.path
    },
    uploadImgToPageDetail () {
      let listingDetails = this.listingDetails
      if(this.headerImgUpload) {
        listingDetails.publicListing.headerImages.push({
          id: this.imgId,
          url: this.mediaUrl
        })
      }
      if(this.footerImgUpload) {
        listingDetails.publicListing.footerImages.push({
          id: this.imgId,
          url: this.mediaUrl
        })
      }
      if(this.toolbarImageUpload) {
        listingDetails.publicListing.toolbarLogo = {
          id: this.imgId,
          url: this.mediaUrl
        }
      }
      this.listingDetails = listingDetails
      this.updateListingPage()
      this.imageUploadDialog = false
      this.mediaUrl = null
    },
    removeImageLink () {
      this.mediaUrl = null,
          this.imgId = ''
    },
    cancelImageUpload () {
      this.imageUploadDialog = false
      this.mediaUrl = undefined
      let userId = this.user.uid
      let storage = getStorage()
      let imgRef = ref(storage, '/users/' + userId + '/' + this.imgPath + '/' + this.imgId)
      this.uploadStatus = ''
      deleteObject(imgRef)
          .then(()=> {
            this.imgPath = ''
          })
          .catch((err) => {
        this.$store.dispatch('setError', err)
      });
    },
    updateListingPage () {
      let db = this.$store.state.db
      let listingRef = doc(db, 'users', this.user.uid, 'listings', this.id)

      this.listingDetails.publicListing.listingName = this.listingDetails.listingName
      let socialIcons = []
      this.socialIcons.forEach(icon => {
        if (icon.tag !== '') {
          socialIcons.push(icon)
        }
      })
      if (socialIcons.length !== 0) {
        this.listingDetails.publicListing.socialIcons = socialIcons
      }

      if (this.listingDetails.publicListing.socialIcons.length !== 0) {
        // let emptyIcons = []
        this.listingDetails.publicListing.socialIcons.forEach(icon => {
          if (icon.tag === '') {
            let socialIcon = this.listingDetails.publicListing.socialIcons.find(obj => {
              return obj.icon === icon.icon
            })
            let index = this.listingDetails.publicListing.socialIcons.indexOf(socialIcon)
            // console.log(index)
            this.listingDetails.publicListing.socialIcons.splice(index, 1)

          }
        })
        // console.log(this.listingDetails.publicListing.socialIcons)
      }
      this.setPublicListingStatus ()
      return updateDoc(listingRef, this.listingDetails)
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    createItem() {
      this.$store.dispatch('setLoading', true)
      let db = this.$store.state.db
      let itemsRef = collection(db, 'users', this.user.uid + '/listings/' + this.id +'/items')
      let item = this.newItem
      let itemId
      addDoc(itemsRef, item)
          .then(res => {
            item.id = res.id
            itemId = item.id
            let itemRef = doc(db, 'users', this.user.uid + '/listings/' + this.id + '/items/' + res.id)
            return updateDoc(itemRef, item)
          })
          .then (() => {
            return this.routeToItem(itemId)
          })
          .catch(err => {
            this.$store.dispatch('setError', err)
            this.newItemDialog = false
            this.$store.dispatch('setLoading', false)
          })
      this.itemName = ''
      this.newItemDialog = false
      this.$store.dispatch('setLoading', false)
    },
    createAddOnItem() {
      this.$store.dispatch('setLoading', true)
      let db = this.$store.state.db
      let addOnItemsRef = collection(db, 'users', this.user.uid + '/listings/' + this.id +'/addOnItems')
      let item = {...this.newAddOnItem}
      // console.log(item)
      addDoc(addOnItemsRef, item)
          .then(res => {
            item.id = res.id
            let itemRef = doc(db, 'users', this.user.uid + '/listings/' + this.id + '/addOnItems/' + res.id)
            return updateDoc(itemRef, item)
          })
          .then (() => {
            this.addOnItems.push(item)
            this.selectedAddOnItem = item
            this.addOnItemDialog = true
            this.newAddOnItemDialog = false
            this.newAddOnItem.title = ''
            this.newAddOnItem.timeFactor = 10
          })
          .catch(err => {
            this.newAddOnItem.title = ''
            this.newAddOnItem.timeFactor = 10
            this.$store.dispatch('setError', err)
            this.newAddOnItemDialog = false
            this.$store.dispatch('setLoading', false)
          })

      this.$store.dispatch('setLoading', false)
    },
    openAddOnItem (item) {
      this.selectedAddOnItem = item
      this.addOnItemDialog = true
    },
    updateAddonItem () {
      // console.log(this.selectedAddOnItem)
      let updateItem = {...this.selectedAddOnItem}
      let db = this.$store.state.db
      let addOnItemRef = doc(db, 'users', this.user.uid + '/listings/' + this.id +'/addOnItems/' + this.selectedAddOnItem.id)
      let selectedItem = this.addOnItems.find(item => {
        return item.id === updateItem.id
      })
      let itemIndex = this.addOnItems.indexOf(selectedItem)
      this.addOnItems[itemIndex] = {...this.selectedAddOnItem}
      return updateDoc(addOnItemRef, updateItem)
          .then (() => {
            this.addOnItemDialog = false
            this.syncAddOnItemToPublic(updateItem)
          })
    },
    deleteAddOnItem () {
      // console.log(this.selectedAddOnItem)
      let db = this.$store.state.db
      let addOnItemRef = doc(db, 'users', this.user.uid + '/listings/' + this.id +'/addOnItems/' + this.selectedAddOnItem.id)
      let removedItem = this.addOnItems.find(item => {
        return item.id === this.selectedAddOnItem.id
      })
      let itemIndex = this.addOnItems.indexOf(removedItem)
      this.addOnItems.splice(itemIndex, 1)
      return deleteDoc(addOnItemRef)
          .then (() => {
            this.addOnItemDialog = false
          })
          .then (()=> {
            removedItem.listed = false
            this.syncAddOnItemToPublic(removedItem)
          })
    },
    syncAddOnItemToPublic (addOnItem) {
      // console.log(addOnItem)
      let db = this.$store.state.db
      let publicListingItemRef = doc(db, 'publicListings', this.user.publicListingId,
          'listings', this.id, 'addOnItems', addOnItem.id)
      if (addOnItem.listed) {
        setDoc(publicListingItemRef, addOnItem)
            .catch(err => {
              this.$store.dispatch('setError', err)
              this.$store.dispatch('setLoading', false)
            })
      } else {
        deleteDoc(publicListingItemRef)
            .catch(err => {
              this.$store.dispatch('setError', err)
              this.$store.dispatch('setLoading', false)
            })
      }
    },
    routeToItem (itemId) {
      this.$router.push('/listing/' + this.id +'/item/' + itemId)
    }
  }
}
</script>

